export default __webpack_public_path__ + "static/media/BG-Yellow-0000.1a2ead2b.png";